"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcademyList = void 0;
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../common");
const academy_1 = require("../../../server/academy");
exports.AcademyList = react_1.default.memo(({ searchOption, initPage, }) => {
    const countRef = react_1.default.useRef(10);
    const [page, setPage] = react_1.default.useState(initPage);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [listData, setListData] = react_1.default.useState([]);
    const { data, refetch } = (0, academy_1.useAcademiesList)({
        member: searchOption,
        offset: page * countRef.current,
        limit: countRef.current,
    });
    const refetchList = (0, lodash_1.throttle)(() => refetch(), 1000);
    const headTitleList = [
        { title: 'academyId', space: 1 },
        { title: 'academyName', space: 3 },
    ];
    const tableReadDataKeys = [
        { title: 'identifier', space: 1 },
        { title: 'nickname', space: 3 },
    ];
    react_1.default.useEffect(() => {
        setPage(initPage);
    }, [initPage]);
    react_1.default.useEffect(() => {
        refetchList();
    }, [searchOption, page]);
    react_1.default.useEffect(() => {
        if (data) {
            const { total_count, items, found_count } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / countRef.current) - 1);
                if (page !== maxPage) {
                    setPage(maxPage);
                    return;
                }
                // 이미 maxPage 인데도 0건 → 서버 total_count·items 불일치. 빈 목록 처리로 폴스루해
                // empty 문구가 노출되게 한다(기존: totalCount 잔존/음수 페이지로 빈 화면·페이지네이션 소실).
            }
            else if (items.length > 0) {
                setListData(items);
                setTotalCount(total_count);
                return;
            }
        }
        setListData([]);
        setTotalCount(0);
    }, [data, page]);
    const handlerMoreData = (page) => {
        setPage(page);
        APP.eventManager.publish('UPDATE_PAGE', page);
    };
    const handlerSelectItem = (item) => {
        APP.eventManager.publish('CHANGE_MENU', {
            showDepth: 'detail',
            props: { ...item },
        });
    };
    const renderEmpty = react_1.default.useMemo(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, "\uB4F1\uB85D\uB41C \uD559\uC6D0\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."))), [totalCount]);
    const renderItem = (item) => {
        if (!item)
            return;
        return tableReadDataKeys.map((headItem, idx) => (react_1.default.createElement("div", { key: idx, className: "table-item", style: {
                flex: headItem.space,
                justifyContent: 'flex-start',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
                cursor: headItem.title === 'nickname' ? 'pointer' : 'default',
            }, onClick: headItem.title === 'nickname' ? () => handlerSelectItem(item) : undefined }, headItem.title === 'nickname' ? (react_1.default.createElement("p", { className: "overText2 underline" }, item[headItem.title])) : (react_1.default.createElement("p", { className: "overText2" }, item[headItem.title])))));
    };
    return (react_1.default.createElement(common_1.Table, { showIndex: true, indexOrder: "desc", isInnerPage: true, isInfinite: false, page: page, data: listData, totalCount: totalCount, headTitleList: headTitleList, renderItem: renderItem, renderEmpty: renderEmpty, handlerMoreData: handlerMoreData }));
});
